module.exports = (__webpack_public_path__ || '') + "static/images/lk-background-7f713eeb6520190eb0d912be725cd81e.png";